/* Inbound network rate of the hls-input ffmpeg (30s average of its socket
 * recv()s — see HlsInputNetIn), independent of what abysmal receives, so it
 * stays live during stalls. */
export default function StreamInputStatusHlsInRate({ log_state }) {
  const rate = log_state.hls_in_rate_30;
  return (
    <div className="flex m-px">
      <div className="flex m-px border-gray-200 border rounded-md">
        <div className="px-2 w-18 bg-gray-100 rounded-l-md">hls in:</div>
        <div className="px-2 w-28">{rate == null ? "?" : `${rate}k`}</div>
      </div>
    </div>
  );
}
